import BaseClient from '@/app/model/api/response/baseApiClient'

class AiAdviceDeleteApi extends BaseClient {
  public doAiAdviceDelete (id: string) {
    const path: string = '/v1/ai-advice/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new AiAdviceDeleteApi()
